import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'api-card',
  templateUrl: 'api-card.component.html',
  styleUrls: ['api-card.component.scss']
}) export class APICardComponent {
  inputValue: string = "";
  ouputValue: string = "";
  @Input('main-api') main_api: string = "";
  constructor(private httpclient: HttpClient){}

  someStaticExample: Array<string> = [
    "2 * (3 + 4)",
    "2 * (12 / 4) * 7 + 2",
    "(2 - 3 + (4 / 2)) * 3",
    // "2 * 3 + 4",
    // "2 * 3 + 4",
  ];

  clicked_to_get_example(){
    this.inputValue = this.someStaticExample[Math.floor(Math.random() * this.someStaticExample.length)];
  }

  clicked_to_get_output(){
    this.httpclient.post(this.main_api, {"str": this.inputValue}, {responseType: 'text', }).subscribe((data)=>{
      this.ouputValue = data;
    })
  }

  clear_input_output(){
    this.inputValue = "";
    this.ouputValue = "";
  }
}
